"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlyHeaderLayoutFeature = void 0;
var _topArea = require("@ori/top-area");
var _components = require("../../components");
const OnlyHeaderLayoutFeature = exports.OnlyHeaderLayoutFeature = {
  ..._components.ChatFeature,
  ..._topArea.TopAreaFeature,
  ..._components.LanguageSwitcherFeature,
  /** Use the Share and Earn functionality internationally between tenants */
  InternationalShareAndEarn: 'BE776F8A-5B13-442B-BBE9-58DD2C7C5F22'
};
